<template>
<div class="thal-page">
  <nav2 :title="$t('ranking.t_1')"></nav2>
  <div class="rank-center">
    <div class="rank-first">
      <div class="rank-first-list" >
        <div class="rank-second">
          <div class="rank-second-position">
            <div class="rank-second-icon"><img src="../../assets/img/main.png"/></div>
            <div class="rank-second-name" v-if="firstArr.length>1">{{ firstArr[1].username }}</div>
            <div v-if="firstArr.length>1"> {{ firstArr[1].win }}</div>
            <div >🏆</div>
          </div>
        </div>
      </div>
      <div class="rank-first-list" >
        <div class="rank-second">
          <div class="rank-second-position">
            <div class="rank-second-icon"><img src="../../assets/img/main.png"/></div>
            <div class="rank-second-name" v-if="firstArr.length>0">{{ firstArr[0].username }}</div>
            <div v-if="firstArr.length>0"> {{ firstArr[0].win }}</div>
            <div>🏆</div>
          </div>
        </div>
      </div>
      <div class="rank-first-list" >
        <div class="rank-second">
          <div class="rank-second-position">
            <div class="rank-second-icon"><img src="../../assets/img/main.png"/></div>
            <div class="rank-second-name" v-if="firstArr.length>2">{{ firstArr[2].username }}</div>
            <div v-if="firstArr.length>2"> {{ firstArr[2].win }}</div>
            <div>🏆</div>
          </div>
        </div>
      </div>
    </div>

    <div class="rank-list">
      <div class="rank-item">
        <div class="rank-first-item" v-for="(item,index) in secondArr" :key="index">
          <span>{{ item.rank }}</span>
          <div class="rank-item-name">
            <img src="../../assets/img/main.png"/>{{ item.username }}
          </div>
          <div class="rank-item-amount">{{ item.win }}</div>
        </div>
      </div>
    </div>

  </div>


</div>
</template>

<script>
  import nav2 from '../THAL/navs'
    export default {
    components:{nav2},
        name: "ranking",
      data(){
      return{
        list:[],
        platform_id:'',
        firstArr:[],
        secondArr:[],
      }
      },
      created() {
        let platform_id=this.$route.query.platform_id;
        if(platform_id!='' && platform_id!=undefined){
          this.platform_id=platform_id;
          this._rank()
        }
      },
      methods:{
        _rank:function (){
          let _self=this;
          this._PublicFun.getData('2', 'get', 'lottery/rank/'+_self.platform_id, {}, function (result) {
            if(result.data['status_code']==200){
              _self.list=result.data['data'];
              _self.firstArr=_self.list.slice(0,3);
              _self.secondArr=_self.list.slice(3,_self.list.length);

            }

          })
        }
      }
    }
</script>

<style scoped>
  .rank-center{
    display: block;
    width: 100%;
    margin: 55px auto;
    padding: 0;
    max-width: 750px;
  }
  .rank-list{
    position: absolute;
    top: 160px;
    left: 0;
    width: 100%;
    bottom: 0;
  }
  .rank-first{
    display: flex;
    width: 94%;
    margin: 0 auto;
  }
  .rank-first-list{
    display: block;
    width: 31%;
    margin: 0;
    padding: 0;
  }
  .rank-first-list:first-child{
    margin-top: 10px;
  }
  .rank-first-list:last-child{
    margin-top: 10px;
  }
  .rank-first-list:nth-child(2){
    margin: 0 3.5%;
  }
  .rank-second{
    display: block;
    width:100%;
    margin: 0 auto;
    text-align: center;
    padding: 0;
    border: 1px solid #DBC17D;
    border-radius: 10px;
    height: 90px;
    position: relative;

  }
  .rank-second-position{
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 100%;
    left: 0;

  }
  .rank-second-position div{
    overflow: hidden;
    white-space: nowrap;
    font-size: 12px;
    width: 100%;
    text-overflow: ellipsis;
    color: #ffffff;
  }
  .rank-second-icon{
    display: block;
    margin: 0 auto;
    padding: 0;
    text-align: center;
  }
  .rank-second-icon img{
    height: 25px;
    width: auto;
  }
  .rank-second-name{
    display: block;
    width: 100%;
    font-size: 13px !important;
    text-align: center;
    color: #DAC17C !important;

  }
  .rank-item{
    display: block;
    width: 94%;
    margin: 5px auto 0;
    padding: 0;
  }
  .rank-first-item{
    display: flex;
    width: 100%;
    margin: 0 auto;
    padding: 8px 0;
    position: relative;
    align-items: center;
    border-bottom: 1px solid #888888;
  }
  .rank-first-item span:first-child{
    color: #ffffff;
  }
  .rank-item-name{
    position: absolute;
    left: 40px;
    top: 50%;
    display: flex;
    align-items: center;
    color: #DAC17C;
    font-size: 13px;
    transform: translateY(-50%);
  }
  .rank-item-name img{
    height: 25px;
    width: auto;
    margin-right: 10px;
  }
  .rank-item-amount{
    position: absolute;
    top: 50%;
    right: 0;
    font-size: 12px;
    color: #ffffff;
    transform: translateY(-50%);
  }

</style>



// WEBPACK FOOTER //
// src/components/THAL/ranking.vue